import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { IEmbed } from '../models/emebd.model';

@Injectable()
export class EmbedData {

  constructor(
    private afDb: AngularFireDatabase
  ) { }

  getEmbed(clientId: string, eventId: string, embedId: string): Observable<IEmbed> {
    return this.afDb.object<IEmbed>(`/Clients/${clientId}/Events/${eventId}/Embed/${embedId}`).valueChanges();
  }

  getEmbedsByEvent(clientId: string, eventId: string): Observable<IEmbed[]> {
    return this.afDb.list<IEmbed>(`/Clients/${clientId}/Events/${eventId}/Embed`, ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/embed.ts